import { Component, Input, OnInit } from '@angular/core';
import { ViewCell } from 'ng2-smart-table';

@Component({
  template: `
    <div style="font-weight: 450 !important; position: relative; top: 5px;">{{getValueFirst()}}</div>
    <div (click)=toggle() *ngIf="!showExpandable" style="font-size:11px !important; color:#7777EE; margin-top:6px; cursor: pointer;">Show Booking Numbers</div>
    <div *ngIf="showExpandable">
      <div *ngFor='let text of getValueExpandable()' style="font-size:11px !important; font-weight: 100 !important; position: relative; top: 5px; margin-top: 8px">{{text}}</div>
    </div>
    <div (click)=toggle() *ngIf="showExpandable" style="font-size:11px !important; color:#7777EE; margin-top:6px; cursor: pointer;">Hide Booking Numbers</div>
  `,
})
export class ExpandableCellContentComponent implements ViewCell, OnInit {

  constructor() { }
  
  @Input() value: string;
  @Input() rowData: any;

  ngOnInit(): void {
  }

  getValueFirst() {
    var newString = this.value.split('||');
    return newString[0];
  }
  getValueExpandable() {
    var newString = this.value.split('||');
    return newString.slice(1);
  }

  showExpandable = false;
  toggle() {
    this.showExpandable = !this.showExpandable;
  }
}
